import { RoleCode } from "../../utils/RolesPermissions";

export const RouteGetUsersList = "/users/list";

export type ResponseGetUsersList = User[];

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  userType: "MERCHANT_USER";
  merchantId: number;
  roleCode: RoleCode;
}
